"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function EvaluatorGroupTableTitle({ evaluatorGroupName, sx }) {
    return (react_1.default.createElement(style_1.ValueWrapper, { sx: sx },
        react_1.default.createElement(style_1.UntoggledValue, { variant: "h3" }, evaluatorGroupName),
        " "));
}
exports.default = EvaluatorGroupTableTitle;
